const removeFromCategories = (categories, index) => {
  if (index >= 0 && index < categories.length) {
    categories.splice(index, 1);
  }

  return categories;
};

export default removeFromCategories;
